import React from "react";

import { getLanguageField } from "../../utils/language";
import SolidColorBackground from "./solidColorBackground";
import SplitGrid from "./splitGrid";
import SplitImage from "./splitImage";

import type { CtaProps, SimpleItem, SplitButtonsItem, SplitGridItem, SplitImageItem } from "./types";
import SplitButtons from "./splitButtons";
import SiteContainer from "src/components/siteContainer";
import { ModuleWrapperV2 } from "src/components/moduleWrapper/moduleWrapper.v2";
import BackgroundImageWrapper from "src/components/backgroundImageWrapper/backgroundImageWrapper";

export default class Cta extends React.Component<CtaProps> {
  renderComponent() {
    const { type } = this.props.data.item;
    if (type === "split_grid") return <SplitGrid item={this.props.data.item as SplitGridItem} selectedLanguage={this.props.data.selectedLanguage} defaultLanguage={this.props.defaultLanguage} />
    if (this.isSimpleType) return <SolidColorBackground item={this.props.data.item as SimpleItem} selectedLanguage={this.props.data.selectedLanguage} defaultLanguage={this.props.defaultLanguage} />
    if (type === "split_image") return <SplitImage isHero={this.props.data.isHero} item={this.props.data.item as SplitImageItem} selectedLanguage={this.props.data.selectedLanguage} defaultLanguage={this.props.defaultLanguage} />
    if (type === "split_buttons") return <SplitButtons item={this.props.data.item as SplitButtonsItem} selectedLanguage={this.props.data.selectedLanguage} />
  }

  get padding() {
    return { top: this.props.data.item.padding_top, bottom: this.props.data.item.padding_bottom };
  }

  //TODO -> solid_color_background and image_background should be replaced in the db for type simple and we can remove this triple condition
  get isSimpleType(){
    const { type } = this.props.data.item;
    return type === "simple";
  }

  get rounded() {
    if (this.props.data.item.width !== 'full_screen' && this.props.data.item.rounded_corners === true) return true;
    return false;
  }

  get isFullWidth() {
    return this.props.data.item.width === 'full_screen';
  }

  get outterMargin() {
    if (this.isFullWidth) return 'mx-auto my-auto';
    if (this.imageFullfill) return "mx-6 xl:mx-auto"
    if (this.constrained) return `${this.alignment}`;
    return 'mx-4 sm:mx-6 xl:mx-0';
  }

  get innerPadding() {
    if (this.imageFullfill) return "px-0"
    if (this.isFullWidth) return 'px-6 xl:px-0';
    return 'px-4 sm:px-6 lg:px-8';
  }

  get backgroundColor(){
    return this.props.data.item?.background_color?.value || "transparent"
  }

  get boxedBackgroundColor(){
    const { boxed_background_color } = this.props.data.item;
    if (!this.isFullWidth) return boxed_background_color?.value || "transparent";
    return "";
  }

  get overlayColor(){
    const { overlay, background_overlay_opacity, background_color_overlay } = this.props.data.item
    if( overlay && background_color_overlay?.value && background_overlay_opacity) return background_color_overlay.value +  Math.floor( background_overlay_opacity / 100 * 255 || 0 * 255).toString(16);
    return "";
  }

  get imageFullfill(){
    //fullfillment only in split_image
    if(this.props.data.item.type === "split_image") return this.props.data.item.fulfill_position;
    return false;
  }

  get style() {
    return {
      '--hyperlink-text-color': this.props.data.item.hyperlink_text_color?.value,
      '--hyperlink-hover-color': this.props.data.item.hyperlink_hover_color?.value,
    }
  }

  get constrained(){
    const { size, width } = this.props.data.item;
    return this.isSimpleType && width === "boxed" && size === "constrained";
  }

  get alignment(){
    const { constrained_alignment } = this.props.data.item;
    if (!this.constrained) return "";
    return constrained_alignment === "center" ? "mx-4 sm:mx-6 lg:mx-auto" : constrained_alignment === "right" ? "mx-4 sm:mx-6 lg:ml-auto xl:mr-0" : "mx-4 sm:mx-6 xl:mx-0";
  }

  get size(){
    return this.constrained ? `lg:max-w-[630px] lg:w-full` : "";
  }

  get contentAlignment(){
    const { content_alignment, alignment } = this.props.data.item as SimpleItem;
    if (this.constrained && alignment === "center") return content_alignment === "left" ? "items-start" : content_alignment === "right" ? "items-end" : "items-center";
    return "";
  }

  getBackgroundImageProps(wrapper:"background-image-wrapper" | "module-wrapper" = "background-image-wrapper"){
    const { image, mobile_background_image, background_image_placement, overlay, background_color_overlay, background_overlay_opacity } = this.props.data.item;

    const overlayColor = overlay && background_color_overlay?.value && background_overlay_opacity ?
    background_color_overlay.value +  Math.floor( background_overlay_opacity / 100 * 255 || 0 * 255).toString(16)
    : "";    

    const props = {
      backgroundImage: image?.imageFile,
      mobileBackgroundImage: mobile_background_image?.imageFile,
      overlayColor: overlayColor
    }
    if(wrapper === "background-image-wrapper" && (background_image_placement === "full_screen" || this.isFullWidth)) return props;
    if(wrapper === "module-wrapper" && background_image_placement === "boxed") return props;
    return {};
  }

  render() {
        return <BackgroundImageWrapper {...this.getBackgroundImageProps("background-image-wrapper")} backgroundColor={this.backgroundColor}>
      <SiteContainer fullwidth={this.isFullWidth}>
        <ModuleWrapperV2
          isFullWidth={this.isFullWidth}
          roundedCorners={this.rounded}
          className={`${this.innerPadding} ${this.outterMargin} flex ${this.size} ${this.contentAlignment}`}
          paddings={this.padding}
          anchor={getLanguageField(this.props.data.item.translations, this.props.data.selectedLanguage, "anchor") as string}
          style={this.style}
          name={getLanguageField(this.props.data.item.translations, this.props.data.selectedLanguage, "name") as string}
          backgroundColor={this.boxedBackgroundColor}
          {...this.getBackgroundImageProps("module-wrapper")}
        >
          {this.renderComponent()}
        </ModuleWrapperV2>
      </SiteContainer>
    </BackgroundImageWrapper>
  }
}